"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _SvgIcon = require("material-ui/SvgIcon");

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AccumulationOfLitter = function AccumulationOfLitter(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    (0, _extends3.default)({ className: "custom-icon", viewBox: "0 0 791.957 791.957" }, props),
    _react2.default.createElement("path", { d: "M493.7726 313.5035H299.7508c-20.4102 0-36.9497 16.5266-36.9497 36.9368l20.0208 212.5842c0 20.3979 16.5519 36.9369 36.9616 36.9369h157.0601c20.4097 0 36.9616-16.539 36.9616-36.937l16.9418-212.584c-.0252-20.4103-16.5642-36.937-36.9744-36.937zm-146.2892 221.784c0 10.1924-8.2695 18.449-18.4748 18.449-10.2049 0-18.4744-8.2694-18.4744-18.449v-166.36c0-10.1924 8.2695-18.4872 18.4744-18.4872 10.2053 0 18.4748 8.2948 18.4748 18.4873v166.3598zm64.6734 0c0 10.1924-8.2695 18.449-18.4743 18.449-10.2049 0-18.4744-8.2694-18.4744-18.449v-166.36c0-10.1924 8.2695-18.4872 18.4744-18.4872 10.2053 0 18.4743 8.2948 18.4743 18.4873v166.3598zm64.6744 0c0 10.1924-8.27 18.449-18.4748 18.449s-18.4744-8.2694-18.4744-18.449v-166.36c0-10.1924 8.2695-18.4872 18.4744-18.4872s18.4748 8.2948 18.4748 18.4873v166.3598zM289.885 295.029l223.6947-57.548c12.3535-3.167 19.7941-15.7601 16.6142-28.1141-3.1795-12.354-15.7725-19.7942-28.1265-16.6524l-68.7584 17.6955c-6.3718-9.4512-18.1354-14.415-29.7981-11.4242l-26.8325 6.925c-11.6632 3.0038-19.568 13.0201-20.5988 24.369l-77.7068 20.008c-12.354 3.167-19.7818 15.7601-16.6148 28.1141 3.18 12.3664 15.773 19.7813 28.127 16.6271z" })
  );
};

exports.default = AccumulationOfLitter;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/custom-icons/accumulation-of-litter.js
// module id = ../lib/egov-ui-kit/custom-icons/accumulation-of-litter.js
// module chunks = 504